module.exports = __webpack_public_path__ + "img/pic1.57961f68.jpeg";